import type { WidgetsGridProps } from "./WidgetsGrid.type";

import { Row, Col, Flex } from "antd";
import { Fragment } from "react";

import "./WidgetsGrid.style.less";
import { CARD_TABS_HEIGHT } from "@/constants/Layout";

const WidgetsGrid = ({
  columnLayout = false,
  widgets = [],
  children,
}: WidgetsGridProps) => {
  if (columnLayout) {
    return (
      <Flex gap="middle" className="widgets-grid-column">
        <div className="column-content">{children}</div>
        <Flex
          vertical
          gap="middle"
          style={{ marginTop: CARD_TABS_HEIGHT }}
          className="column-widgets"
        >
          {widgets.map(({ component, key }) => (
            <Fragment key={key}>{component}</Fragment>
          ))}
        </Flex>
      </Flex>
    );
  }

  return (
    <div className="widgets-grid-row">
      <Row gutter={[16, 16]} className="row-widgets">
        {widgets.map(({ component, key, colSpan }) => (
          <Col span={colSpan ?? 8} key={key}>
            {component}
          </Col>
        ))}
      </Row>
      <div className="row-content">{children}</div>
    </div>
  );
};

export default WidgetsGrid;
